import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
export function SiteLayout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-canvas text-ink" data-id="element-137" data-mp="3i0wjym5ifqeu">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:shadow" data-id="element-138" data-mp="jviss1l5cm6">
        Skip to content
      </a>
      <SiteHeader data-id="element-139" data-mp="345ki7usxszof" />
      <main id="main" className="flex-1" data-id="element-140" data-mp="2z93wt8d4gzf1">
        <Outlet data-id="element-141" data-mp="2z8auqkp3yy38" />
      </main>
      <SiteFooter data-id="element-142" data-mp="2z6zqykvnxqc4" />
    </div>;
}